import { SchoolService, BaseService } from "@/services/school.service";

const SettingsService = {
    getAll () {
        return SchoolService.getAll("settings")
    },

    add(payload) {
    	return SchoolService.create("settings", payload)
    },

    update(id, object) {
    	return SchoolService.update("settings", id, object)
    },

    // Criteria
    addCriteria(payload) {
    	return SchoolService.create("settings/criteria", payload)
    },

    updateCriteria(id, object) {
    	return SchoolService.update("settings/criteria", id, object)
    },

    // Grades
    addGrades(payload) {
        return SchoolService.create("settings/grades", payload)
    },

    updateGrades(id, object) {
        return SchoolService.update("settings/grades", id, object)
    },

}

export { SettingsService };